import script from "./user-card.vue?vue&type=script&setup=true&lang=js"
export * from "./user-card.vue?vue&type=script&setup=true&lang=js"

import "./user-card.vue?vue&type=style&index=0&id=6e9b9268&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9b9268"]])

export default __exports__